import { z } from 'zod/v4';

import { VIDEO_EDIT_MODEL_OPTIONS } from './constants';

export const DEFAULT_VIDEO_EDIT_USE_CASE_ID = 'change-object';

const videoEditFormSchema = z.object({
    prompt: z.string().trim().min(1, 'Prompt is required'),
    sourceVideo: z.string().min(1, 'Source video is required'),
});

export type VideoEditFormState = z.infer<typeof videoEditFormSchema> & {
    useCase: string;
    model: string;
    contentId: number | null;
    startTime: number;
    duration: number;
    validationActive: boolean;
};

export type VideoEditFormErrors = Partial<Record<keyof z.infer<typeof videoEditFormSchema>, string>>;

export const VIDEO_EDIT_FORM_DEFAULTS: VideoEditFormState = {
    prompt: '',
    sourceVideo: '',
    useCase: DEFAULT_VIDEO_EDIT_USE_CASE_ID,
    model: VIDEO_EDIT_MODEL_OPTIONS[0].value,
    contentId: null,
    startTime: 0,
    duration: 5,
    validationActive: false,
};

export function validateVideoEditForm(state: VideoEditFormState): {
    isValid: boolean;
    errors: VideoEditFormErrors;
} {
    const result = videoEditFormSchema.safeParse(state);
    if (result.success) {
        return { isValid: true, errors: {} };
    }

    const errors: VideoEditFormErrors = {};
    for (const issue of result.error.issues) {
        const field = issue.path[0];
        if (typeof field === 'string' && field in VIDEO_EDIT_FORM_DEFAULTS) {
            errors[field as keyof VideoEditFormErrors] = issue.message;
        }
    }
    return { isValid: false, errors };
}
